import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { ConversationService } from "@/services/conversation/conversation.service";
import { downloadCsv } from "@/utils/csv";
import { showError } from "@/utils/notification";

export const useDownloadMessageVocs = (
  conversationId: string | null,
  messageId: string | null,
) => {
  const { t } = useTranslation("voiceek_ui");
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = useCallback(async () => {
    if (!conversationId || !messageId) return;
    setIsDownloading(true);
    try {
      const blob = await ConversationService.downloadMessageVocs(conversationId, messageId);
      downloadCsv(blob, `${messageId}.csv`);
    } catch (error) {
      console.error(error);
      showError(t("chat.download.error"));
    } finally {
      setIsDownloading(false);
    }
  }, [conversationId, messageId, t]);

  return { handleDownload, isDownloading };
};
